import { _Collection_liquid } from "../../@types/shopify";

const initCollectionCard = ($el: HTMLElement, $refs: Record<string, HTMLElement>, collectionHandle: string) => {
  const random_id = utils.shortUUID();

  const collection =
    _collections[collectionHandle] ||
    utils.JSONParse<_Collection_liquid>(document.querySelector(`[data-collection-data="${collectionHandle}"]`)?.innerHTML);

  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...(collection ?? {}),
    url: collection?.url ?? `/collection/${collection?.handle}`,
  });

  const getDynamicValue = (content: string) => {
    return utils.getBracketInputDynamicValue(content, state);
  };

  const getDynamicValueWithFallbacks = (content: string) => {
    return content.split(",")?.reduce((acc, item) => {
      acc ||= utils.getBracketInputDynamicValue(item.trim(), state);
      return acc;
    }, "");
  };

  const getDynamicText = (content: string) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  };

  const getContentLabels = (key: string) => {
    const labels = key.split(".").reduce<any>((acc, selector) => {
      if (!selector || acc === undefined || acc === null) return acc || "";

      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);

    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  };

  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
  };
};

const fallbackHydrationQueue = new Set<HTMLElement>();

const hydrateCollectionCardContent = ($el: HTMLElement) => {
  const card_handle = $el.getAttribute(`data-card-handle`);
  const collection_handle = $el.getAttribute(`data-collection-handle`);
  const collection_id = $el.getAttribute(`data-collection-id`);
  const classes = utils.JSONParse<string[]>($el.getAttribute(`data-card-classes`) ?? "[]");

  const node = document.querySelector(`[data-collection-card='${card_handle}']`)?.cloneNode(true) as HTMLElement;

  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }

  node?.removeAttribute(`data-collection-card`);
  node?.setAttribute("data-collection-handle", collection_handle);
  node?.setAttribute("data-collection-id", collection_id);
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });

  node.classList.add(...classes);
  $el.parentNode?.replaceChild(node, $el);
};

document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateCollectionCardContent(el);
  });
  fallbackHydrationQueue.clear();
});

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateCollectionCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);

const hydrateCollectionCard = ($el: HTMLElement) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateCollectionCardContent($el);
    return;
  }

  observer.observe($el);
};

export type InitCollectionCard = typeof initCollectionCard;
export type HydrateCollectionCard = typeof hydrateCollectionCard;

window._sections["initCollectionCard"] = initCollectionCard;
window._sections["hydrateCollectionCard"] = hydrateCollectionCard;
